export default __webpack_public_path__ + "static/media/campSiteIcon.f282afbf.svg";